import React, { useState , useEffect } from 'react';
import axios from 'axios';
import URL from '../constants/ServerUrl';
import { useNavigate , useSearchParams } from 'react-router-dom';
import { convertDateToAD , convertDateToBS } from '../utils/convertDate';
import moment from 'moment'
import { NepaliDatePicker } from "nepali-datepicker-reactjs"
import { formatDateInBS } from '../utils/formatDate'

const EditPayment = ({ route }) => {

    const [searchParams] = useSearchParams();
    const username = searchParams.get('username');
    const id=searchParams.get('id')
    const [isPickerShow, setIsPickerShow] = useState(false)
    const [date, setDate] = useState(convertDateToBS(new Date(Date.now())))
    const [newAmountToPay, setNewAmountToPay] = useState('');
    const [newRemarks, setNewRemarks] = useState('change');
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false)
    const navigator = useNavigate();
    const token = localStorage.getItem("dairy-token")

    const [paymentData, setPaymentData] = useState(null);
    const [error, setError] = useState('');


        // const getPaymentById = async () => {
        //     try {
        //         // Replace with your API endpoint and parameters
        //         const  data  = await axios.get(`${URL}admin/${username}/payment/${id}`,{

        //             Authorization: `Bearer ${token}`,

        //         });
        //         setPaymentData(data);
        //         console.log(paymentData);
        //     } catch (err) {
        //         console.error('Error fetching payment data:', err);
        //         setError(err.message || 'An error occurred while fetching payment data');
        //     }
        // };

        // useEffect(()=>{
        //     getPaymentById();
        // },[])


        const onChange = ( date) => {
            setDate(date)
          }
        
          const showPicker = () => {
            setIsPickerShow(true)
          }

    const updatePayment = async () => {
        try {
            if (username) {
                setIsLoading(true);

                console.log(date);
                console.log(id);

                const datetosend=convertDateToAD(date);

                const paymentResponse = await axios.put(

              
                
                    `${URL}admin/${username}/payment/${id}`,
                    {
                        amountToPay: Number(newAmountToPay),
                        remarks: newRemarks,
                        date:datetosend
                      
                    },{
                        Authorization: `Bearer ${token}`,

                    }
                )

                if (paymentResponse.status === 200) {
                    setIsLoading(false)
                    alert('Payment Updated')
                    navigator('/CollectionCenter')
                }
            }
            navigator(-1);
        } catch (err) {
            setIsLoading(false);
            alert('Error updating payment');
            console.log(err);
        }
    };

    const deletePayment = async () => {
        try {
            if (username) {
                setIsDeleting(true)
                const deleteResponse = await axios.delete(
                    `${URL}admin/${username}/payment/${id}`,{
                        Authorization: `Bearer ${token}`,
                    }
                )

                if (deletePayment.status === 200) {
                    setIsDeleting(false)
                    alert('Data Deleted')
               
                }
            }

            navigator(-1);
            
        }
        catch (err) {
            setIsDeleting(false)
            alert('Error while Deleting')
            console.log(err)
        }
    }

    return (
        <div className="p-4 bg-gray-50">
        <div className="flex flex-col space-y-4">
          <div className="flex items-center mb-3">
            {!isPickerShow && (
              <button
                className="border border-gray-300 rounded-md py-2 px-4 text-gray-700 hover:bg-gray-100 transition duration-150 ease-in-out"
                onClick={showPicker}
              >
                <div>{(date)}</div>
              </button>
            )}
      
            {isPickerShow && (
              <NepaliDatePicker
                value={date}
                onChange={onChange}
                options={{ calenderLocale: 'en', valueLocale: 'en' }}
              />
            )}
          </div>
      
          <input
            className="border border-gray-300 rounded-md py-2 px-4 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Amount to Pay"
            type="text"
            value={newAmountToPay}
            onChange={(text) => setNewAmountToPay(text.target.value)}
          />
      
          <input
            className="border border-gray-300 rounded-md py-2 px-4 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Remarks"
            type="text"
            value={newRemarks}
            onChange={(text) => setNewRemarks(text.target.value)}
          />
      
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition duration-150 ease-in-out disabled:opacity-50"
            onClick={() => {
              if (!isLoading) {
                updatePayment();
              }
            }}
            disabled={isLoading}
          >
            {isLoading ? 'Updating...' : 'Update Payment'}
          </button>
      
          <button
            className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-md transition duration-150 ease-in-out disabled:opacity-50"
            onClick={() => {
              if (!isDeleting) {
                deletePayment();
              }
            }}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete Collection'}
          </button>
        </div>
      </div>
      
    );
};


export default EditPayment;